import { useMutation, useQueryClient } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import { baseURL } from "@/Environment";
import { QUERY_KEYS } from "../query/querykeys";
import { AxiosResponseAndError } from "../types/axiosResponseType";
import { ProjectBaselineResponseType } from "../query/useProjectBaselineQuery";

export const useSaveProjectBaselineMutation = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponseAndError<ProjectBaselineResponseType>["response"],
    AxiosResponseAndError<ProjectBaselineResponseType>["error"],
    void
  >({
    mutationFn: async () => {
      return await ApiRequest.post(`${baseURL}/api/project/${projectId}/baseline`, {});
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.projectBaseline, projectId] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.projectPerformance, projectId] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.projectSummary, projectId] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjectDetails, projectId] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allTask, projectId] });
    },
  });
};

